import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Typography, Stack } from "@mui/material";
import PropTypes from "prop-types";

function LoadingBackdrop({ message = "Loading..." }) {
  return (
    <div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 999 }}
        open
      >
        <Stack spacing={1} justifyContent="center" alignItems="center">
          <CircularProgress color="inherit" />
          {message ? <Typography>{message}</Typography> : ""}
        </Stack>
      </Backdrop>
    </div>
  );
}

LoadingBackdrop.propTypes = {
  message: PropTypes.string,
};

export default LoadingBackdrop;
